var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "610" },
      on: {
        "click:outside": function($event) {
          return _vm.closeDialog()
        }
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-container",
            [
              _c(
                "v-card-title",
                { staticClass: "my-0 py-0 pt-0 ml-4 heading-6" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "my-2",
                      attrs: { justify: "space-between" }
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { align: "start" } },
                        [
                          _c("div", { staticClass: "text-no-wrap" }, [
                            _vm._v(" " + _vm._s(_vm.config.label) + " ")
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0 ma-0 pr-4",
                          attrs: { align: "end" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.closeDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dense: "" } }, [
                                _vm._v("mdi-close")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "px-2 py-2", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-2 px-2", attrs: { cols: "6" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            transition: "scale-transition",
                            "offset-y": "",
                            "close-on-content-click": false,
                            "nudge-top": "25",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            value: _vm.formattedDates,
                                            label: _vm.config.label,
                                            readonly: _vm.readOnly,
                                            rules: [_vm.isValidDateRange],
                                            outlined: "",
                                            "prepend-inner-icon":
                                              "mdi-calendar",
                                            dense: "",
                                            "background-color": "#fff",
                                            "hide-details": "",
                                            "validate-on-blur": "",
                                            clearable: !_vm.readOnly
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.datePicker = true
                                            },
                                            "click:clear": _vm.clearDates
                                          }
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      !_vm.readOnly ? on : null
                                    )
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.datePicker,
                            callback: function($$v) {
                              _vm.datePicker = $$v
                            },
                            expression: "datePicker"
                          }
                        },
                        [
                          _vm.datePicker && !_vm.readOnly
                            ? _c("v-date-picker", {
                                attrs: {
                                  "allowed-dates": _vm.allowedDates,
                                  min:
                                    _vm.contractDate.start_dt || _vm.config.min,
                                  range: "",
                                  "show-current": "",
                                  scrollable: "",
                                  "no-title": ""
                                },
                                model: {
                                  value: _vm.dates,
                                  callback: function($$v) {
                                    _vm.dates = $$v
                                  },
                                  expression: "dates"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-2 px-2", attrs: { cols: "6" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            transition: "scale-transition",
                            "offset-y": "",
                            "close-on-content-click": false,
                            "nudge-top": "25",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          ref: "offerField",
                                          attrs: {
                                            value: _vm.formattedOfferDates,
                                            readonly: _vm.readOnly,
                                            disabled: _vm.offerDisabled,
                                            rules: [_vm.isValidOfferDateRange],
                                            outlined: "",
                                            label: "Perishable Offer Start/End",
                                            "prepend-inner-icon":
                                              "mdi-calendar",
                                            dense: "",
                                            "background-color": "#fff",
                                            clearable: !_vm.readOnly
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.offerDatePicker = true
                                            },
                                            "click:clear": _vm.clearOfferDates
                                          }
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      !_vm.readOnly ? on : null
                                    )
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.offerDatePicker,
                            callback: function($$v) {
                              _vm.offerDatePicker = $$v
                            },
                            expression: "offerDatePicker"
                          }
                        },
                        [
                          _vm.offerDatePicker && !_vm.readOnly
                            ? _c("v-date-picker", {
                                attrs: {
                                  min:
                                    _vm.contractDate.offer_start_date ||
                                    _vm.config.min,
                                  "allowed-dates": _vm.allowedOfferDates,
                                  range: "",
                                  "show-current": "",
                                  scrollable: "",
                                  "no-title": ""
                                },
                                model: {
                                  value: _vm.offerDates,
                                  callback: function($$v) {
                                    _vm.offerDates = $$v
                                  },
                                  expression: "offerDates"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }